<template>
	<div class="enterprisewebsite" v-title :data-title="pagedata.title" >
		<headerbar :curindex="curindex"></headerbar>
	 <div class="newsTopics" style="margin-top:10px;">
			<div class="topicbanner">
				<img :src="pagelist[0].image" alt="">
				<!-- <h2 class="title tac "></h2> -->
				</div>
			<div class="oh centerpage whitebox topicsummary">
				<h4 class="title">专题摘要</h4>
				<span :class="pagedata.collectId == 0?'collectbtn add fr':'collectbtn remove fr'" @click="collectFun()">{{pagedata.collectId == 0?'+添加收藏':'取消收藏'}}</span> 
			 <div class="summary" v-html="pagelist[1].content"></div>
			</div>
			<div class="oh centerpage flexcss">
				<div class="leftconbox">
					<dl class="topic_newlist whitebox" v-for="list in huatilist">
						<dt class="title">{{list.moduleName}}</dt> 
						<dd v-for="item in list.newsList" @click="routerlinkid('/news',item.id)" :data="item.id">
						<!-- 	<img src="../../../assets/topicimg.png" alt="" class="fl topicimg"> -->
							<div class="fl titltbox">
								<h5 class="smtitle a-router">{{item.title}}</h5>
								<p class="date">{{item.date}}</p>
							</div>
							<p class="stargrade1 stargrade fr"><i class="starfull" v-for="star in item.star"></i><i class="stargray" v-for="star in (5-item.star)"></i></p>
						</dd> 
					</dl> 
				</div>
				<div class="rightrecommend">
					<div class="whitebox hottopic">
						<h4 class="title">热门专题</h4>
						<ul>
							<li v-for="item in hottopic" @click="routerlinkid('/newsTopics',item.id)"><span class="onlyline">{{item.title}}</span></li>
						</ul> 
					</div> 
				</div> 
			</div>
		</div> 
		<footerbar></footerbar>
	</div>
</template>

<script>
	export default {
	  name: 'newsTopics',
	  data(){return{
				msg:"资讯专题",
				pagetypes:1,
				topicid:0,
				pagedata:{},
				pagelist:[{image:"",},{content:"",moduleName:''}],
				huatilist:[],
				hottopic:[],
				curindex:1,
				title:"", 
			}}, 
			created() {
				this.bus.$emit('loading',false);
				this.getuserinfor(); 
				this.getpagelist();
				this.gethottopic()
			},
			mounted() { 	},
			methods:{
				//公用部分
				getuserinfor(){
					this.bus.$emit('loading',true);
					let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
					if(typeof(dataddd) == 'object'){
					this.userdata = dataddd;
					}else{
					this.userdata = JSON.parse(dataddd);
					}
					this.topicid=this.$route.query.id*1;   
				},
				//添加删除收藏
				collectFun(){
					// console.log(this.pagedata.collectId,this.pagedata.collectType);
					var _this=this,cid=this.pagedata.collectId;
					var ajaxurl="",ajaxdata={};
					if(cid == 0){
					 ajaxurl=this.$api.cyl.collect.add();
						ajaxdata={type:this.pagedata.collectType,id:this.topicid}
						}else{
							ajaxurl=this.$api.cyl.collect.remove();
							ajaxdata={collectId:this.pagedata.collectId};
						} 
						console.log(ajaxurl,ajaxdata);
					$.ajax({
						type:"POST",
						url:ajaxurl,
						data:ajaxdata,
						headers:{AuthToken:this.userdata.token },
						success:function(res){ 
							console.log(res);
							if(res.success){
								if(cid == 0){
									_this.pagedata.collectId=res.data.collectId;
								}else{
									_this.pagedata.collectId=0;
								} 
							} 
						} 
					}) 
				},
				getpagelist(){
					var _this=this;
					this.$axios.get(this.$api.cyl.zttopic.detail()+'?id='+this.topicid,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						// 11-9 稍微有点数据
						console.log(res.data);
						_this.pagedata=res.data.data;
						_this.pagelist=res.data.list;
						_this.huatilist=res.data.list.filter(data=>{
							if(data.newsList == null){
								data.newsList=[];
							}
							return data.moduleType==3;
						});
						console.log(_this.huatilist)
						document.title=res.data.data.title;
						_this.bus.$emit('loading',false);
					// _this.chainnodelist=; 
					}) 
				},
				gethottopic(){
					var _this=this;
					this.$axios.get(this.$api.cyl.zttopic.list()+'?reco=+&exclude='+this.topicid,{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
						console.log(res.data);  
						_this.hottopic=res.data.list;
					}) 
				},
		} 
	}
	
	
	
</script>

<style scoped="scoped">  
</style>   
